import env from '../BsGetEnv'
import bsGetXcx from './../BsGetXcx';
function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}
function fomatTime(num) {
  return num < 10 ? ('0' + num) : num.toString()
}
function getNowtime() {
  const date = new Date()
  const yyyy = fomatTime(date.getFullYear())
  const MM = fomatTime(date.getMonth() + 1)
  const dd = fomatTime(date.getDate())
  const hh = fomatTime(date.getHours())
  const mm = fomatTime(date.getMinutes())
  const ss = fomatTime(date.getSeconds())
  return yyyy + MM + dd + hh + mm + ss
}

function get_cookie(name) {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  let arr = document.cookie.match(reg); 
  return arr ? unescape(arr[2]) : ''
}

function set_cookie(name, value, time) { 
  let domain = env.isEnVlocal? '': ';domain=.didachuxing.com'
  document.cookie = name + '=' + value + '; max-age=' + (time||7)*24*60*60 + domain;
}

function isObject(obj){
    return Object.prototype.toString.call(obj) === '[object Object]';
}

function isString(obj){
    return Object.prototype.toString.call(obj) === '[object String]';
}

function isNumber(obj){
  return Object.prototype.toString.call(obj) === '[object Number]';
}

function isBoolean(obj){
  return Object.prototype.toString.call(obj) === '[object Boolean]';
}

function isArray(obj){
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function isFunction(obj){
  return Object.prototype.toString.call(obj) === '[object Function]';
}
// 判断版本号
// v1 > v2 ==> 1
// v1 < v2 ==> -1
// v1 == v2 ==> 0
function compareVersion(v1, v2)  {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i], 10);
    const num2 = parseInt(v2[i], 10);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}


function getQuery(str) {
    var theRequest = {};
    var strs = (str || location.search.substr(1)).split("&");
    for (var i = 0; i < strs.length; i++) {
        let query = strs[i].split("=");
        if(query.length === 2){
          theRequest[query[0]] = decodeURIComponent(query[1]);
        }
    }
    return theRequest;
}

function stringify(obj){
  function dep(obj,key){
    var params ='';
    if(isObject(obj)){
      Object.keys(obj).forEach(item=>{
        params += dep(obj[item], key ? `${key}[${item}]`:`${item}`)
      })
    }else if(isArray(obj)){
      for(var i = 0 ; i < obj.length; i++){
        params += dep(obj[i], key ? `${key}[${i}]`:`${i}`)
      }
    } else if(!isFunction(obj)){
      return key + `=` + obj + `&`;
    }
    return params
  }
  if(!obj) return '';
  let params = dep(obj);
  return encodeURI(params.substring(0, params.lastIndexOf('&')));
}

const currentEnv = (async function (){
  if(env.isDidaPinche){
      return 'carpoolapp' // 顺风车app
  }else if(env.isDidaTaxi){
      return 'taxiapp' // 顺风车app
  }
  let appId = getQueryString('appId')
  let xcx = await bsGetXcx();
  if(xcx.isWx){
      return appId || 'wx7f9416391161a1a0'
  } else if(xcx.isAli){
      return appId || '2019112669404960'
  }else if(env.inWechat){
      return 'carpool_wx' // 微信环境
  }else if(env.isAlipay){
      return 'carpool_ali' // 支付宝环境
  }
})()

export default {
  queryString: getQueryString,
  nowTime: getNowtime,
  getCookie: get_cookie,
  setCookie: set_cookie,
  isObject,
  isString,
  isNumber,
  isBoolean,
  isArray,
  isFunction,
  getQuery,
  compareVersion,
  stringify,
  currentEnv
}